import { axiosbaseurl } from "configure"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import AddHoursTime from "./AddHoursTime"
import { usePermissionData } from "AppContext"

const TimeHistory = ({
  show,
  setShow,
  taskData,
  setTaskData = () => {},
  isApproval = false,
  settable_data,
}) => {
  const { checkAccess } = usePermissionData()
  const module_id = 24

  const [logs, setLogs] = useState([])

  const [view, setView] = useState(false)
  const [details, setDetails] = useState({})
  const [viewHeading, setViewHeading] = useState("")

  const [editShow, setEditShow] = useState(false)
  const [ids, setIds] = useState({})

  useEffect(() => {
    if (!show) {
      setLogs([])
      setTaskData(null)
    }
  }, [show])

  useEffect(() => {
    const getLogs = async () => {
      try {
        const response = await axiosbaseurl.get(
          `/task-updates/${taskData?.task}`
        )
        if (response.data.success) {
          const logsdata = response.data.data
            .map(item => ({
              ...item,
              employeeName:
                item?.employee?.name + " " + item?.employee?.lastName || "",
            }))
            .filter(log => !log.timer)
          setLogs(logsdata)
        }
      } catch (error) {
        console.log(error)
      }
    }
    if (taskData?.task) getLogs()
  }, [taskData])

  function calculateTimeDifference(startTime, endTime) {
    // Parse the start and end times as moment objects with format 'HH:mm'
    const start = moment(startTime, "HH:mm")
    const end = moment(endTime, "HH:mm")

    // If end time is earlier than start time, add a day to end time
    if (end.isBefore(start)) {
      end.add(1, "days")
    }

    // Calculate the difference in minutes
    const duration = moment.duration(end.diff(start))

    // Get total hours and minutes
    const hours = String(Math.floor(duration.asHours())).padStart(2, "0") // Ensure two digits
    const minutes = String(duration.minutes()).padStart(2, "0") // Ensure two digits

    return `${hours}:${minutes}`
  }

  function isEditable(date, approval) {
    return (
      moment(date).format("DD-MM-YYYY") === moment().format("DD-MM-YYYY") &&
      !isApproval &&
      approval === null
    )
  }

  return (
    <>
      <Modal
        size="xl"
        fullscreen
        isOpen={show}
        toggle={() => setShow(!show)}
        centered={true}
      >
        <div className="modal-content">
          <ModalHeader className="w-100 bg-primary px-5">
            <div className="d-flex align-items-center justify-content-between w-100">
              <div>
                <div className="fs-5 d-flex text-white">
                  <h4 className="mb-0 text-white me-5 fw-bold">Task Logs </h4>
                  <div>
                    <strong>Client Name</strong> :{" "}
                    {taskData?.clientName && ` ${taskData?.clientName} `}
                  </div>
                  <div className="ms-4">
                    <strong>Task Name</strong> :{" "}
                    {taskData?.taskName && ` ${taskData?.taskName} `}
                  </div>
                </div>
              </div>
              <div>
                <button
                  className="btn btn-danger "
                  onClick={() => setShow(!show)}
                >
                  <i className="fa fa-times me-2"></i> Close
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody className="px-5 ">
            <div className="mt-2">
              <table
                className="table table-bordered text-center"
                style={{ verticalAlign: "middle" }}
              >
                <thead className="table-primary">
                  <tr>
                    <th>Employee</th>
                    <th>Work Type</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Total Hours</th>
                    <th>Date</th>
                    <th>Task Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map(log => {
                    const docUrl = `${process.env.REACT_APP_IMAGE_PATH}/${log.taskLogDocument}`
                    return (
                      <tr key={log.id}>
                        <td> {log.employeeName} </td>
                        <td className="text-capitalize">
                          {" "}
                          {log?.workType?.workType || "N/A"}{" "}
                        </td>
                        <td>
                          {" "}
                          {moment(log.startTime, "HH:mm:ss")
                            .local()
                            .format("hh:mm A")}{" "}
                        </td>
                        <td>
                          {" "}
                          {moment(log.endTime, "HH:mm:ss")
                            .local()
                            .format("hh:mm A")}{" "}
                        </td>
                        <td>
                          {calculateTimeDifference(log.startTime, log.endTime)}{" "}
                          hrs{" "}
                        </td>
                        <td>{moment(log.createdAt).format("DD MMM, YYYY")} </td>
                        <td>
                          {" "}
                          <span
                            className={`badge fs-6 ${
                              log?.status?.statusName ? "" : "text-dark"
                            }`}
                            style={{
                              color: log?.status?.colorCode,
                              border: `1px solid ${log?.status?.colorCode}`,
                            }}
                          >
                            {log?.status?.statusName || "N/A"}{" "}
                          </span>{" "}
                        </td>

                        <td>
                          <div className="text-end">
                            {/* edit */}
                            {checkAccess(module_id, "edit") &&
                              (isEditable(log.createdAt, log.isApproved) ||
                                isApproval) && (
                                <button
                                  onClick={() => {
                                    setEditShow(true)
                                    setIds({
                                      ...taskData,
                                      logId: log.id,
                                      ...(isApproval && { adminEdit: true }),
                                    })
                                  }}
                                  className="btn btn-success bg-green  btn-sm me-2"
                                  type="button"
                                >
                                  <i className="fas fa-pen"></i>
                                </button>
                              )}

                            {!isApproval &&
                              log.editReason &&
                              log.editReason !== "null" && (
                                <button
                                  onClick={() => {
                                    setView(true)
                                    setDetails({
                                      type: "editReason",
                                      log: log,
                                    })
                                    setViewHeading("Edited By Admin")
                                  }}
                                  className="btn btn-secondary btn-sm me-2"
                                  title="Edited By Admin"
                                >
                                  <i className="fas fa-eye"></i>
                                </button>
                              )}

                            <button
                              onClick={() => {
                                setEditShow(true)
                                setIds({
                                  ...taskData,
                                  logId: log.id,
                                  adminView: true,
                                  // ...(isApproval && { adminView: true })
                                })
                              }}
                              className="btn btn-primary btn-sm "
                              title="View Details"
                            >
                              <i className="fas fa-eye"></i> View
                            </button>

                            {log.taskLogDocument && (
                              <a
                                href={docUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-sm btn-dark ms-2"
                                title="Attachment File"
                              >
                                <i className="fas fa-download"></i>
                              </a>
                            )}
                          </div>
                        </td>
                      </tr>
                    )
                  })}

                  {logs.length === 0 && (
                    <tr className="text-center">
                      <td colSpan={10}>No Logs Found!</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        size="lg"
        isOpen={view}
        toggle={() => setView(!view)}
        centered={true}
      >
        <div className="modal-content">
          <ModalBody className="px-3 ">
            <div className="d-flex justify-content-between pb-2 mb-4 border-bottom">
              <h5 className="text-capitalize">
                {viewHeading} (
                {moment(details?.log?.createdAt).format("DD MMM, YYYY")})
              </h5>
              <button
                type="button"
                className="btn-close "
                onClick={() => setView(!view)}
              ></button>
            </div>

            <div
              dangerouslySetInnerHTML={{
                __html: details?.log ? details?.log[details?.type] : "",
              }}
            />
          </ModalBody>
        </div>
      </Modal>

      <AddHoursTime
        show={editShow}
        setShow={setEditShow}
        ids={ids}
        setLogsPopup={setShow}
        setTaskData={settable_data}
      />
    </>
  )
}

export default TimeHistory
